var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2495 2.2334H3.31543V10.8286",
    stroke: "#CACACA",
    strokeWidth: 1.32235,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95996 4.87842H13.894V12.8125C13.894 13.1632 13.7547 13.4995 13.5067 13.7475C13.2587 13.9955 12.9224 14.1348 12.5717 14.1348H7.28231C6.9316 14.1348 6.59526 13.9955 6.34727 13.7475C6.09928 13.4995 5.95996 13.1632 5.95996 12.8125V4.87842Z",
    stroke: "#CACACA",
    strokeWidth: 1.32235,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyWhite);
export default __webpack_public_path__ + "static/media/copy-white.ab432c3fdc73832b2acf0eb463b4ad6a.svg";
export { ForwardRef as ReactComponent };